import React, {useEffect, useState} from "react";
import { Empty,Button } from "antd";
import { useNavigate } from "react-router-dom";
import { getFieldStyle } from "../../themes.js";
import "./rdbtable.scss";
import useRDBStore from "../../store/rdb.js";

export default function RDBTable({
    isClickable = false,
    titleList,
    data,
    isEditField,
    emptyString,
    columnWidth,
    showButton,
    setUserMetaData,
    jdClickHandler,
    selectedResumeID
}) {
    const navigate = useNavigate();
    const {rdbLinkHistoryClean}  = useRDBStore()
    const [currentTableData, setTableData] = useState(data);

    useEffect(() => {
        setTableData(data);  
        ///console.log("UseEffect Params")     
    }, [data]);    

    if (!data || data.length ==0) {
        return <>
                 {emptyString}
        </> ;
    }

    const handleJDClick = (id,jdId) => {
        if (jdClickHandler){
            jdClickHandler(id,jdId,selectedResumeID)
        }
    };
 
   const handleRDBHistroyClean = (id)=>{
     rdbLinkHistoryClean()
     setTableData([])
     setUserMetaData(...[])
   };
    return (
        <div className="rdbtable-wrapper">
          <>
              
          </>
          {
                showButton == true?
                <>
                    <div className="rdbtable-Button">
                        <div className="rdbtable-Button-item">
                            Linked Profiles History
                        </div>
                        <Button
                            disabled={!showButton}
                            onClick={handleRDBHistroyClean}
                        >
                            Clear History
                        </Button>
                    </div>                 
                </>:
                <>
                </>
          }          
           
            <div
                className="rtable-title-wrapper"
                style={{
                    gridTemplateColumns: columnWidth
                }}
            >
                {titleList.map((title) => (
                    <div className="rtable-title">{title}
                    </div>
                ))}
            </div>
            {currentTableData?.map((table, rowIndex) => (
                <div
                    onClick={ isClickable?()=>handleJDClick(table.id, table.jdId):null }
                    key={table.id}
                    className="rtable-info-wrapper"
                    style={{
                        gridTemplateColumns: columnWidth,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="rtable-info"
                             style={
                                     { ...getFieldStyle(tableInfo, table[tableInfo])}                                                
                                    }
                           >
                            {isEditField ? (
                               <></>
                            ) : (
                                table[tableInfo]===""?"--":table[tableInfo]
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
